import { NgModule } from '@angular/core';
import { ChemSketchImportComponent } from 'app/modules/dossier-area/entry-components/chemsketch-import/chemsketch-import.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'app/core/services/toast-service';
import { TranslateModule } from '@ngx-translate/core';
import { GenericUploadModule } from 'app/shared/components/generic-upload';
@NgModule({
  imports: [CommonModule, FormsModule, ToastModule, TranslateModule, GenericUploadModule],
  declarations: [ChemSketchImportComponent],
  exports: [ChemSketchImportComponent],
})
export class ChemSketchImportModule {}
